var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBox',[_c('OmtTypography',{attrs:{"as":"p2","pb":"18px"}},[_c('strong',[_vm._v("Pedido médico do ano vigente, emitido por profissional médico devidamente registrado no CRM com:")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }